<template>
    <div class='h100-40 h-scroll'>
        <ejs-grid ref="grid" :dataSource="counterDataList" :rowSelected='rowSelectedOfCounterDataList' :rowDeselected='rowDeselectedOfCounterDataList'>
            <e-columns>
                <e-column field="counterName" :headerText='$t("Pm.counterName")' textAlign="center"  width="20%"  clipMode="EllipsisWithTooltip" :formatter="counterNameFormatter"></e-column>
                <e-column field="unitName" :headerText='$t("Pm.counterUnit")' textAlign="center"  width="20%"  clipMode="EllipsisWithTooltip" :formatter="unitNameFormatter"></e-column>
                <e-column field="counterType" :headerText=`${$t("Pm.realTime")}/${$t("Pm.nonRealTime")}` textAlign="center"  width="20%"  clipMode="EllipsisWithTooltip" :formatter="realOrNoRealFormatter"></e-column>
                <e-column field="counterNameOfThreshold" :headerText='$t("Pm.thresholdSetStatus")' textAlign="center" :disableHtmlEncode='false' width="20%"  clipMode="EllipsisWithTooltip" :formatter="thresholdStatusFormatter"></e-column>
                <e-column field="activeStatus" :headerText='$t("Pm.thresholdActiveStatus")' textAlign="center" :disableHtmlEncode='false' width="20%"  clipMode="EllipsisWithTooltip" :formatter="activeStatusFormatter"></e-column>
            </e-columns>
        </ejs-grid>
        <ejs-pager ref='pagerOfcounterDataList' @click="getCounterListData" :currentPage='pageSettings.currentPage' :pageCount='pageSettings.pageCount' :pageSize='pageSettings.pageSize' :totalRecordsCount='pageSettings.totalRecordsCount'></ejs-pager>
    </div>
</template>

<script>
    import {PmEventBus} from "../../../../util/PmEventBus";

    export default {
        name: "CounterListContent",
        props:[
            'queryParam'
        ],
        data(){
            return {
                counterDataList: [],
                pageSettings: {
                    currentPage: 1,
                    pageSize: 18,
                    totalRecordsCount: 0,
                    pageCount: 10
                },
                realNoReal: new Map()
                    .set(1, this.$t('Pm.nonRealTime'))
                    .set(2, this.$t('Pm.realTime'))
                    .set(3, `${this.$t('Pm.realTime')}/${this.$t('Pm.nonRealTime')}`),
                activaStatus: new Map()
                  .set('1', this.$t('Pm.active'))
                  .set('0', this.$t('Pm.hangup')),
                rowDataOfCounterDataList: '',
                counterName: null
            }
        },
        methods: {
            activeStatusFormatter(column,data){
              return this.activaStatus.get(data[column.field]);
            },
            rowSelectedOfCounterDataList(msg){
                this.rowDataOfCounterDataList = msg.data;
                this.$emit('taskStatusChange', msg.data.activeStatus);
            },
            rowDeselectedOfCounterDataList(msg){
                this.rowDataOfCounterDataList = '';
                this.$emit('taskStatusChange', msg.data.activeStatus);
            },
            thresholdStatusFormatter(column,data){
              return data[column.field] == null ? `<span class='no-threshold'>${this.$t('Pm.thresholdNotSet')}</span>`: `<span class='have-threshold'>${this.$t('Pm.thresholdHasSet')}</span>`;
            },
            realOrNoRealFormatter(column,data){
                return this.realNoReal.get(data[column.field]);
            },
            counterNameFormatter(column,data){
                return (this._i18n.locale === 'zh') ? data['counterNameCH'] : data['counterNameOT'];
            },
            unitNameFormatter(column,data){
                return (this._i18n.locale === 'zh') ? data['unitCH'] : data['unitOT'];
            },
            getCounterListData(param){
                const language = localStorage.getItem('locale');
                this.pageSettings.currentPage = this.$refs.pagerOfcounterDataList.ej2Instances.currentPage;
                this.$loading.showLoadding(this.$t('System.loading'));
                this.$axios.post('/lte/ems/pm/counterManagement/getCounterList.html', {
                    neTypeCode: param != undefined && param.neVersion != null && param.neVersion != undefined ? param.neTypeCode : this.queryParam.neTypeCode,
                    neVersion: param != undefined && param.neVersion != null && param.neVersion != undefined ? param.neVersion : this.queryParam.neVersion,
                    measureObjTypeCode: param != undefined && param.neVersion != null && param.neVersion != undefined ? param.measureObjTypeCode : this.queryParam.measureObjTypeCode,
                    measureObjCode: param != undefined && param.neVersion != null && param.neVersion != undefined ? param.measureObjCode : this.queryParam.measureObjCode,
                    counterType: 1,
                    counterNameCh: language == 'zh' ? this.counterName : null,
                    counterNameOt: language == 'zh' ? null : this.counterName,
                    page: {
                        pageNo: this.pageSettings.currentPage,
                        pageSize: this.pageSettings.pageSize
                    }
                }).then((response) => {
                    const result = response.data.resultVal;
                    this.pageSettings.totalRecordsCount = result.totalCount;
                    this.pageSettings.currentPage = result.pageNo;
                    this.counterDataList = result.result;
                    this.$loading.hideLoadding();
                });
            }
        },
        mounted() {
            this.getCounterListData();
            PmEventBus.$on('searchByCounterName',(counterName) => {
                this.counterName = counterName;
                const language = localStorage.getItem('locale');
                this.pageSettings.currentPage = 1;
                this.$loading.showLoadding(this.$t('System.loading'));
                this.$axios.post('/lte/ems/pm/counterManagement/getCounterList.html', {
                    neTypeCode: this.queryParam.neTypeCode,
                    neVersion: this.queryParam.neVersion,
                    measureObjTypeCode: this.queryParam.measureObjTypeCode,
                    measureObjCode: this.queryParam.measureObjCode,
                    counterType: 1,
                    counterNameCh: language == 'zh' ? counterName : null,
                    counterNameOt: language == 'zh' ? null : counterName,
                    page: {
                        pageNo: this.pageSettings.currentPage,
                        pageSize: this.pageSettings.pageSize
                    }
                }).then((response) => {
                    const result = response.data.resultVal;
                    this.pageSettings.totalRecordsCount = result.totalCount;
                    this.pageSettings.currentPage = result.pageNo;
                    this.counterDataList = result.result;
                    this.$loading.hideLoadding();
                });
            })
        }
    }
</script>

<style>
  .have-threshold,
  .no-threshold {
    font-size: 12px;
    display: inline-block;
    width: 100px;
    height: 22px;
    color: #fff;
    line-height: 22px;
  }

  .no-threshold{
    background-color: #FF0000;
  }

  .have-threshold {
    background-color: #13C2C2;
  }

</style>
